export default __webpack_public_path__ + "static/18-1ef1dded1ced7c22185841f0d139875d.jpg";